import { useEffect, useLayoutEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { usePolicyStore } from '@/entities/Policy/model/store';
import { useOAuth } from '@/features/PolicyRegistration/lib/query/useOAuth';
import { PageLoader } from '@/shared/ui/PageLoader';
import { Wrapper } from '@/shared/ui/Wrapper';

type Props = {};

const AuthPage = (props: Props) => {
    const { setIsSuccess } = usePolicyStore();
    const { mutate: oAuth, isSuccess, error } = useOAuth();
    const [searchParams, setSearchParms] = useSearchParams('');

    useLayoutEffect(() => {
        if (searchParams.get('state') !== null && searchParams.get('code') !== null) {
            oAuth({ id: searchParams.get('state') as string, code: searchParams.get('code') as string });
            setSearchParms({});
        }
    }, [searchParams.size !== 0]);

    useEffect(() => {
        setIsSuccess(isSuccess);
    }, [isSuccess]);

    return (
        <Wrapper>
            <PageLoader />
        </Wrapper>
    );
};

export default AuthPage;
